

export const displayBankAccountChanges = async (functionParameters={})=> {

    const getSubtitleAndParagraphForBankAccount = (await import(/* webpackPrefetch: true */ `@schaniag/private`)).getSubtitleAndParagraphForBankAccount;

    const { accountNumber, bankCountry, bankName, accountCurrency, smetioPresentationClass, logo, coverPhoto, name, status, address, preloaderClass, smartbox, textClass, model, uniqueValues, titleClass, subTitleClass, paragraphClass } = functionParameters;
    
    // const last4DigitOfAccNumb = accountNumber.substr(-4);
    // const bankFirstName = bankName.split(" ")[0];

    // const subTitle = `${bankFirstName} **** ${last4DigitOfAccNumb}`;
    // const paragraph = `${bankCountry.toUpperCase()} - ${accountCurrency.toUpperCase()}`;

    const {subTitle, paragraph} = getSubtitleAndParagraphForBankAccount({accountNumber, bankName, bankCountry, accountCurrency });

    smetioPresentationClass.changeSubtitle(subTitle);
    smetioPresentationClass.changeParagraph(paragraph);
};
